import { withThemeCreator } from '@material-ui/styles';
import defaultTheme from './defaultTheme';
var withTheme = withThemeCreator({
  defaultTheme: defaultTheme
});
export default withTheme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/styles/withTheme.js
// module id = 1173
// module chunks = 0